<template>
  <v-container
    id="Bslab"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-eye-refresh"
      class="px-5 py-3"
      width="100%"
    >
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="linea"
            class="ma-2"
            :items="linee"
            item-text="text"
            item-value="iso"

            label="Linea"
            persistent-hint
            single-line
            @change="resetForm"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="modello"
            placeholder="forma"
            class="ma-2"
            required
            :error="formaHasError"
            :error-messages="formaErrorMessages"
            hint="inserire codice o numero della forma desiderata"
            @keyup.enter="get_bslab"
          >
            <v-icon
              slot="append"
              :color="this.$vuetify.theme.currentTheme.primary"
              @click="get_bslab"
            >
              mdi-send
            </v-icon>
          </v-text-field>
        </v-col>
      </v-row>

      <!-- {{ bslab }} -->
      <template v-if="bslab &&bslab.length > 0">
        <template v-for="(lente,idx ) in bslab">
          {{ bslab[idx].name }}
          <v-img
            :key="`img_${idx}`"
            :src="'data:image/jpeg;base64,' + lente.b64img"
            width="250"
            contain
          />

          <v-divider :key="`div_${idx}`" />
        </template>
      </template>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Bslab',
    components: {

    },
    data () {
      return {
        loading: false,
        bslab: null,
        linee: ['SWF', 'SWF_ARTS', 'JOY', 'JOY_BABY', 'CLIP', 'CLIP_CONTUR', 'CLIP_SWF', 'RAINBOW', 'MONOGRAM'],
        linea: null,
        modello: null,
        formaHasError: false,
        formaErrorMessages: [],
        cliente: null,
        valid: true,
        order: {},
        lens: {},
        img: [],
        puntidisponibili: 0,

        desrif: '',
        rifRules: [
          v => !!v || 'Riferiemento è obbligatorio',
          // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],

        menu_data_lenti: false,
        dataord_lenti: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

        // email: '',
        // emailRules: [
        //   v => !!v || 'E-mail is required',
        //   v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        // ],
        // select: null,
        // items: [
        //   'Item 1',
        //   'Item 2',
        //   'Item 3',
        //   'Item 4',
        // ],
        // checkbox: false,

      }
    },
    computed: {
      ...mapState(['auth']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      config () {
        return Config
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      var codcli = `${codsog}${coddes}`
      console.log('analisi codcli', codcli)

      // this.get_bslab()
      // this.get_anagrafica(codcli)
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_anagrafica (codcli) {
        this.loading = true
        engine.get_anagrafica(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.cliente = result.data
            this.get_puntiDisponibili(codcli)
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      get_bslab () {
        if (this.modello.length < 3) {
          this.formaHasError = true
          this.formaErrorMessages = ['Richiesti almeno 3 caratteri']
          return
        }
        this.loading = true
        engine.get_bslab(this.linea, this.modello)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.bslab = result || 0
            // this.drawImage(this.bslab[0], 0)
            // for (var idx in this.bslab) {
            //   console.log('load img', idx, this.bslab[idx])
            //   this.drawImage(this.bslab[idx], idx)
            // }
            this.loading = false
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onSubmit () {
        this.valid = this.$refs.form.validate()
        if (this.valid) {
          console.log('send', this.lens)
          const data = { lens: this.lens, cliente: this.cliente }
          engine.sendRiparazione(data).then((result) => {
            if (result) {
              // alert('Form has been submitted!')
              console.log('sendRiparazione', result)
              this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
            }
          })
            .catch((errore) => {
              // eslint-disable-next-line no-console
              console.error('ERR####', errore)
            })
          return
        }
        this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
        this.$vuetify.goTo(0) // scroll top
        console.log('send invadlid', this.lens)

        // engine.sendOrder(this.lens, this.page).then((result) => {
        //   if (result) {
        //     // alert('Form has been submitted!')
        //     console.log('update newitem', result)
        //     this.$emit('updateItem', result)
        //     this.$emit('close')
        //   }
        // })
        //   .catch((errore) => {
        //     // eslint-disable-next-line no-console
        //     console.error('ERR####', errore)
        //     this.$store.commit('setSnack', { message: 'General Error', color: '#c54747d4' })
        //   })
      },

      resetForm () {
        this.img = []
        this.modello = null
        this.formaHasError = false
        this.formaErrorMessages = []
      },
    },
  }

</script>
<style>
#riparazioni .bordered{
  border:1px solid #ccc;

}
</style>
